import { useAppSelector } from '@editor/store/app'

import { PolylineToolState } from '../Polyline/store/core'

export const usePolylineSelector = <T>(selector: (slice: PolylineToolState) => T): T =>
  useAppSelector((state) => selector(state.tools.polyline))
